<template>
  <div>
    <b-card>
      <template #header>
        <div class="d-flex align-items-center">
          <feather-icon icon="UserIcon" class="mr-2" style="font-size: 20px"></feather-icon>
          <h5 class="mb-0">Editar Empleado</h5>
        </div>
      </template>

      <validation-observer ref="simpleRules">
        <b-form>
          <b-tabs content-class="mt-2" pills>
            <b-tab>
              <template #title>
                <feather-icon icon="FileTextIcon" />
                <span>Detalles de Empleado</span>
              </template>

              <b-row class="mt-3 justify-content-center">
                <b-button variant="outline-primary" class="mb-1 mb-sm-0 mr-2" :to="{ name: 'employees' }">
                  <feather-icon icon="ArrowLeftCircleIcon" class="mr-0 mr-sm-50"></feather-icon>
                  Volver Atrás
                </b-button>
              </b-row>

              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>ID</h4>
                    <b-form-input id="input-id" v-model="body.pkid_accreditation_document_detail"
                      :plaintext="togglePlaintext" readonly />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <validation-provider #default="{ errors }" name="Nombre" rules="required|min:3">
                      <h4>Nombre</h4>
                      <b-form-input id="input-default" size="lg" v-model="body.Nom_titular" required
                        :state="errors.length > 0 ? false : null" autofocus :disabled="disable" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <!-- Apellidos -->
              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <validation-provider #default="{ errors }" name="Apellido1">
                      <h4>Apellido 1</h4>
                      <b-form-input id="input-default" size="lg" v-model="body.Cognom1_titular" required
                        :state="errors.length > 0 ? false : null" :disabled="disable" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Apellido 2</h4>
                    <b-form-input id="input-default" size="lg" v-model="body.Cognom2_titular" :disabled="disable" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <!-- DNI y Fecha de nacimiento -->
              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>DOI</h4>
                    <b-form-select size="lg" v-model="body.DOI_Type" :options="dniOptions" :disabled="disable" />
                    <validation-provider v-if="body.DOI_Type === 'DNI'" #default="{ errors }" name="DOI" rules="dni" >                      
                      <b-form-input v-if="body.DOI_Type === 'DNI'" id="input-default" size="lg" maxlength="9"
                        v-model="body.DNI" :plaintext="togglePlaintext" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                    <validation-provider v-if="body.DOI_Type === 'Other'" #default="{ errors }" name="DOI" rules="">
                      <b-form-input size="lg" :plaintext="togglePlaintext" v-model="body.DNI" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Fecha Nacimiento</h4>
                    <flat-pickr :disabled="disable" v-model="body.Data_neixament" class="form-control" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <!-- Fechas de inicio y fin -->
              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Email</h4>
                    <b-form-input id="input-email" v-model="body.email" :disabled="disable" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Teléfono</h4>
                    <b-form-input id="input-telefon" v-model="body.telefon" maxLength="12" :disabled="disable" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>



              <!-- Acreditación -->
              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <validation-provider #default="{ errors }" name="Inicio Acreditación" rules="required">
                    <b-form-group :state="errors.length > 0 ? false : null">
                      <h4>Fecha Inicio Acceso</h4>
                      <flat-pickr :disabled="disable" v-model="body.datetime_start_acreditation"
                        :state="errors.length > 0 ? false : null" class="form-control" :config="{
                          enableTime: true,
                          defaultDate: body.datetime_start_acreditation,
                          time_24hr: true,
                          locale: {
                            firstDayOfWeek: 1,
                          },
                        }" />
                    </b-form-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                  <validation-provider #default="{ errors }" name="Fin Acreditación" rules="required">
                    <b-form-group :state="errors.length > 0 ? false : null">
                      <h4>Fecha Fin Acceso</h4>
                      <flat-pickr :disabled="disable" v-model="body.datetime_end_acreditation"
                        :state="errors.length > 0 ? false : null" class="form-control" :config="{
                          enableTime: true,
                          defaultDate: body.datetime_end_acreditation,
                          time_24hr: true,
                          locale: {
                            firstDayOfWeek: 1,
                          },
                        }" />
                    </b-form-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Aforo-Acceso</h4>
                    <b-form-select size="lg" v-model="body.AccesSCA" :options="dooraccesoptions" :disabled="disable" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Horario Acceso</h4>
                    <b-form-select size="lg" v-model="body.timetables" :options="timetableOptions"
                      :disabled="disable" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Estado Acceso</h4>
                    <b-form-select size="lg" v-model="docStatusSelected" :options="docStatusOptions"
                      @change="configureDocStatus()" :disabled="disable" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                  <validation-provider #default="{ errors }" name="Empresa_Nom">
                    <b-form-group>
                      <h4>Empresa</h4>
                      <div class="d-flex align-items-center">
                        <b-form-select size="lg" v-model="companySeleceted" :options="companies"
                          @change="configureComany()" v-if="!body.manualEntry" class="flex-grow-1" />
                        <b-form-input v-if="body.manualEntry" v-model="body.manualCompanyName"
                          placeholder="Ingrese el nombre de la empresa" size="lg" class="mt-2" />
                        <b-form-checkbox class="ml-3" v-model="body.manualEntry" :disabled="true"
                          plain>Manual</b-form-checkbox>
                      </div>
                    </b-form-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <h4>Puertas Permitidas</h4>
                  <b-input-group class="mb-1" style="max-width: 750px;">
                    <b-form-input id="filterInput" v-model="filter2" type="search" placeholder="Buscar..."
                      :disabled="disable" />
                  </b-input-group>
                  <div style="max-height: 200px; overflow-y: auto">
                    <b-table striped hover responsive small :items="items2" :fields="fields2" :filter="filter2"
                      :disabled="disable">
                      <template #cell(Active)="data">
                        <b-form-checkbox v-model="data.item.tempActive" switch size="lg" :disabled="disable" />
                      </template>
                    </b-table>
                  </div>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <b-row class="mt-3">
                <h4>Credenciales</h4>
                <b-col class="text-right">
                  <b-button variant="success" @click="addCard" class="mb-1" :disabled="disable">
                    Añadir credencial
                  </b-button>
                </b-col>
              </b-row>

              <b-table striped hover responsive class="position-relative" :per-page="perPage"
                :current-page="currentPage" :items="items" :fields="fields">
                <template #cell(actions)="data">
                  <b-button size="sm" variant="info" @click="openEditModal(data.item)" class="mr-1" :disabled="disable">
                    Editar
                  </b-button>
                </template>

                <template #cell(card_type)="data">
                  <b-badge :variant="activeLabel[1][data.item.card_type]"
                    class="d-inline-flex align-items-center gap-2 p-2 text-dark">
                    <img v-if="data.item.card_type === 'mifare'" :src="require('@/assets/images/icons/card.png')"
                      alt="MiFare" title="MiFare" style="height: 30px" />
                    <img v-else-if="data.item.card_type === 'carplate'" :src="require('@/assets/images/icons/car.png')"
                      alt="CarPlate" title="CarPlate" style="height: 30px" />
                    <span>
                      {{ activeLabel[0][data.item.card_type] }}
                    </span>
                  </b-badge>
                </template>

                <template #cell(active)="data">
                  <b-badge :variant="data.value ? 'success' : 'danger'">
                    {{ data.value ? "true" : "false" }}
                  </b-badge>
                </template>
              </b-table>

              <!-- Modal de edición -->
              <b-modal v-model="showEditModal" title="Editar Tarjeta" @ok="onModalOk" @hidenn="resetForm"
                ok-title="Guardar" cancel-title="Cancelar" :disabled="disable">
                <b-form @submit.prevent="submitForm">
                  <b-form-group label="Número Tarjeta">
                    <b-form-input v-model="selectedCard.card_number" required :disabled="disable" />
                  </b-form-group>
                  <b-form-group label="Tipo Tarjeta">
                    <b-form-select v-model="selectedCard.card_type" :options="cardTypeOptions" required
                      :disabled="disable" />
                  </b-form-group>
                  <b-form-group label="Activo">
                    <b-form-checkbox v-model="selectedCard.active">
                      {{ selectedCard.active ? "Sí" : "No" }}
                    </b-form-checkbox>
                  </b-form-group>
                </b-form>
              </b-modal>

              <!-- Modal de edición -->
              <b-modal v-model="showCreateModal" title="Crear Tarjeta" @ok="handleCreateCard" ok-title="Guardar"
                cancel-title="Cancelar">
                <b-form @submit.prevent="handleCreateCard">
                  <b-form-group label="Número Tarjeta" label-for="card-number">
                    <b-form-input id="card-number" v-model="selectedCard.card_number"
                      :state="errors.card_number ? false : null" />
                    <b-form-invalid-feedback v-if="errors.card_number">
                      {{ errors.card_number }}
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group label="Tipo Tarjeta" label-for="card-type">
                    <b-form-select id="card-type" v-model="selectedCard.card_type" :options="cardTypeOptions"
                      :state="errors.card_type ? false : null" />
                    <b-form-invalid-feedback v-if="errors.card_type">
                      {{ errors.card_type }}
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group>
                    <b-form-checkbox v-model="selectedCard.active">Activo</b-form-checkbox>
                  </b-form-group>
                </b-form>
              </b-modal>


              <!-- Botones de acción -->
              <b-row class="mt-3 justify-content-center">
                <b-button v-if="isEditing" variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                  @click.prevent="validationForm" :disabled="disable">
                  <feather-icon icon="SaveIcon" class="mr-0 mr-sm-50"></feather-icon>
                  Actualizar Empleado
                </b-button>
                <b-button variant="outline-primary" class="mb-1 mb-sm-0 mr-2" :to="{ name: 'employees' }">
                  <feather-icon icon="ArrowLeftCircleIcon" class="mr-0 mr-sm-50"></feather-icon>
                  Volver Atrás
                </b-button>
              </b-row>
            </b-tab>

            <b-tab>
              <template #title>
                <feather-icon icon="LogInIcon" />
                <span>Histórico de Accesos</span>
              </template>
              <div class="d-flex justify-content-center align-items-center">
                <b-button variant="outline-primary" class="mb-1 mb-sm-0 mr-2" :to="{ name: 'employees' }">
                  <feather-icon icon="ArrowLeftCircleIcon" class="mr-0 mr-sm-50"></feather-icon>
                  Volver Atrás
                </b-button>
              </div>
              <b-form-group v-for="filter in filtersConfig.filter(
                (f) => f.type === 'date-range'
              )" :key="filter.key">
                <h5>{{ filter.label }}</h5>
                <b-input-group>
                  <b-form-input v-model="filters.startDateFilter" type="date" placeholder="Start Date" class="mr-2" />
                  <b-form-input v-model="filters.endDateFilter" type="date" placeholder="End Date" class="ml-2" />
                  <b-input-group-append>
                    <b-button variant="primary" @click="applyFilter">
                      <feather-icon icon="SearchIcon" />
                    </b-button>
                    <b-button variant="outline-secondary" @click="clearFilter">
                      <feather-icon icon="XIcon" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>

              <b-table striped hover responsive class="position-relative" :per-page="perPage"
                :current-page="currentPage" :items="items1" :fields="fields1">
                <template #cell(StatusDescription)="data">
                  <b-badge :variant="statusVariant(data.item.StatusDescription)">
                    {{ data.item.StatusDescription }}
                  </b-badge>
                </template>
                <template #cell(StatusDescription_Offline)="data">
                  <b-badge :variant="statusVariant(data.item.StatusDescription_Offline)
                    ">
                    {{ data.item.StatusDescription_Offline }}
                  </b-badge>
                </template>
              </b-table>

              <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
                <!-- page length -->
                <b-form-group label="Por página" label-cols="6" label-align="left" label-size="sm"
                  label-for="sortBySelect" class="text-nowrap mb-md-0 mr-1">
                  <b-form-select id="perPageSelect" v-model="perPage" size="sm" inline :options="pageOptions" />
                </b-form-group>

                <!-- pagination -->
                <div>
                  <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" first-number
                    last-number prev-class="prev-item" next-class="next-item" class="mb-0">
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </div>
              </b-card-body>
            </b-tab>
          </b-tabs>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {
  BTable,
  BCard,
  BCardText,
  BTabs,
  BTab,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BInputGroup,
  BInputGroupPrepend,
  BRow,
  BCol,
  BFormSelect,
  BCardBody,
  BPagination,
  BBadge,
  BFormInvalidFeedback,
  BFormValidFeedback,
  BInputGroupAppend,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import axios from "@/libs/axios";
import { ref } from "@vue/composition-api";
import { extend } from "vee-validate";
import { regex } from "vee-validate/dist/rules";
import { decryptString } from "@/libs/crypto";
import vSelect from "vue-select";
import router from "@/router";
import moment from "moment";

extend("dni", {
  ...regex,
  params: ["lazy"],
  validate: (value) => {
    if (/^(\d{8})([A-Z])$/.test(value)) {
      if (
        "TRWAGMYFPDXBNJZSQVHLCKE".charAt(parseInt(value, 10) % 23) ===
        value.charAt(8)
      ) {
        return true;
      }
      return "La DOI letra es incorecta";
    }
    return "La DOI no es valida";
  },
});

export default {
  components: {
    BTable,
    BCard,
    BCardText,
    BTabs,
    BTab,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BInputGroup,
    BInputGroupPrepend,
    BRow,
    BCol,
    BFormSelect,
    BCardBody,
    BPagination,
    BBadge,
    BFormInvalidFeedback,
    BFormValidFeedback,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    flatPickr,

    flatPickr,
    vSelect,
  },

  watch: {
    aforoPermitSelected(value) {
      this.body.Aforo_permit = "";
      let first = true;
      value.forEach((element) => {
        const idAforo = element.split(" - ")[1].replace(/[()]/g, "");
        if (first) {
          this.body.Aforo_permit = idAforo;
          first = false;
        } else {
          this.body.Aforo_permit += "," + idAforo;
        }
      });
    },
  },

  methods: {

    configureDocStatus() {
      const docStatus = this.docStatusSelected.split(" - ");
      this.body.fkid_accreditation_status = docStatus[0];
      this.body.DocStatus = docStatus[1];
    },
 async validationForm() {
      try {
        const currentUserId = decryptString(localStorage.getItem("idUser")) || "unknown";

        const success = await this.$refs.simpleRules.validate();
        if (!success) return;

        // Actualizamos datos de la persona ANTES de la pregunta
        const [error, pkidOrMessage] = await this.onSubmit();
        if (error) {
          this.$bvToast.toast(String(pkidOrMessage), {
            title: "Error",
            variant: "danger",
            solid: true,
          });
          return; // si hay error, salimos
        }

        // Filtrar puertas que cambiaron
        const doorsToUpdate = this.items2
          .filter(d => d.tempActive !== d.wasActive)
          .map(d => ({
            pkid_door: d.pkid_door,
            Active: d.tempActive ? 1 : 0,
          }));

        if (doorsToUpdate.length > 0) {
          // Enviar userId aparte, junto con las puertas
          await axios.put(`/DoorByPerson/${pkidOrMessage}`, {
            userId: currentUserId,
            doors: doorsToUpdate
          });
        }

        this.isEditing = false;
        this.togglePlaintext = true;
        this.disable = true;
        this.$bvToast.toast("Visitante editado correctamente", {
          title: "Update",
          variant: "success",
          solid: true,
        });

        // Ahora ya tenemos los datos actualizados, mostramos pregunta
        const confirmed = await this.$bvModal.msgBoxConfirm(
          "Quieres actualizar los dispositivos de acceso?",
          {
            title: "Enviar Dispositivos",
            size: "sm",
            buttonSize: "sm",
            okVariant: "primary",
            okTitle: "Sí",
            cancelTitle: "No",
            cancelVariant: "secondary",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        );

        if (confirmed) {
          // Actualización de credenciales
          const url = process.env.VUE_APP_URL_API_UPDATE_CREDENTIALS;
          await axios.post(url, { id: pkidOrMessage });


          this.$bvToast.toast("Post visitante enviado correctamente", {
            title: "Post enviado",
            variant: "info",
            solid: true,
          });


        }
      } catch (error) {
        console.error("Error en validationForm:", error);
        this.$bvToast.toast(error.response?.data?.error || "Error general", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      }
    },

    async applyFilter() {
      try {
        let startDate, endDate;
        const formatDate = (d) => d.toISOString().split("T")[0];

        // Si el usuario no ha seleccionado nada, usamos últimos 7 días
        if (!this.filters.startDateFilter || !this.filters.endDateFilter) {
          const today = new Date();
          const sevenDaysAgo = new Date();
          sevenDaysAgo.setDate(today.getDate() - 7);
          startDate = formatDate(sevenDaysAgo);
          endDate = formatDate(today);
          // volcamos las fechas por defecto en los inputs
          this.filters.startDateFilter = startDate;
          this.filters.endDateFilter = endDate;
        } else {
          // usamos lo que haya puesto el usuario
          startDate = this.filters.startDateFilter;
          endDate = this.filters.endDateFilter;
        }

        const response = await axios.get(
          "/accred-sca-registrySE",
          {
            params: {
              fkid_accreditation: this.$route.params.id,
              startDate,
              endDate,
            },
          }
        );

        this.items1 = response.data;
        this.totalRows = this.items1.length;
      } catch (error) {
        this.$bvToast.toast("Error al cargar datos", {
          title: error.message,
          variant: "danger",
          solid: true,
        });
      }
    },

    clearFilter() {
      // Limpiamos los filtros (a null) y recargamos con rango por defecto
      this.filters.startDateFilter = null;
      this.filters.endDateFilter = null;
      this.applyFilter();
    },

    configureAforoMain() {
      const aforo = this.aforoMainSelected.split(" - ");
      const idAforo = aforo[1].replace(/[()]/g, "");
      this.body.Aforo_main = idAforo;
    },
    configureComany() {
      const company = this.companySeleceted.split(" - ");
      const idCompany = company[1].replace(/[()]/g, "");
      this.body.fkid_accreditation_company = idCompany;
      this.body.Empresa_nom = company[0];
    },


    async message() {
      this.body.Matricula = this.matriculasInput
        .split(",")
        .map((item) => item.trim());

      const error = await this.onSubmit();
      if (error[0]) {
        const variant = "danger";
        this.$bvToast.toast("" + error[1], {
          title: "Error",
          variant,
          solid: true,
        });
      } else if (!error[0]) {
        this.togglePlaintext = true;
        this.date = true;
        this.hiddenComponent = true;
        const variant = "success";
        this.$bvToast.toast("Empleado editado correctamente", {
          title: "Update",
          variant,
          solid: true,
        });
      }
    },

    openEditModal(card) {
      this.selectedCard = {
        ...card,
        active: card.active === 1 || card.active === true,
      };
      this.showEditModal = true;
    },

    async onModalOk(bvModalEvt) {
    bvModalEvt.preventDefault(); 

    const success = await this.saveCard();

    if (success) {
      this.showEditModal = false; 
    }
  },

  async saveCard() {
    try {
      if (!this.selectedCard || !this.selectedCard.pkidcard) {
        throw new Error("No se ha seleccionado una tarjeta válida para editar");
      }

      await axios.put(`/cards/${this.selectedCard.pkidcard}`, {
        pkid_accreditation_document_detail:
          this.selectedCard.fkid_accreditation_document_detail,
        card_number: this.selectedCard.card_number.replace(/\s/g, ""),
        card_type: this.selectedCard.card_type,
        active: this.selectedCard.active,
        user_creation: decryptString(localStorage.getItem("idUser")),
      });

      const index = this.items.findIndex(
        (item) => item.pkidcard === this.selectedCard.pkidcard
      );
      if (index !== -1) {
        this.items.splice(index, 1, { ...this.selectedCard });
      }

      this.$bvToast.toast("Credencial actualizada correctamente", {
        title: "Éxito",
        variant: "success",
        solid: true,
      });

      await this.loadCards();
      return true;
    } catch (error) {
      const backendMessage =
        error.response?.data?.error || "Error al actualizar la credencial";

      this.$bvToast.toast(backendMessage, {
        title: "Error",
        variant: "danger",
        solid: true,
      });
      return false;
    }
  },


    //añadir tarjetas al pkid
    async addCard() {
      try {
        this.selectedCard = {
          pkidcard: null,
          card_number: "",
          card_type: "mifare",
          active: true,
          user_creation: "",
        };

        this.showCreateModal = true;
      } catch (error) {
        console.error("Error al intentar agregar credencial:", error);
        this.$bvToast.toast(error.message, {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      }
    },

    //abrir el modal para crear tarjetas
    async handleCreateCard(bvModalEvt) {
      bvModalEvt.preventDefault();

      // Limpiar errores previos
      this.errors.card_number = '';
      this.errors.card_type = '';

      let hasError = false;

      if (!this.selectedCard.card_number) {
        this.errors.card_number = 'El número de credencial es obligatorio';
        hasError = true;
      }

      if (!this.selectedCard.card_type) {
        this.errors.card_type = 'El tipo de credencial es obligatorio';
        hasError = true;
      }

      if (!this.$route.params.id) {
        this.$bvToast.toast("No se ha obtenido el ID del empleado", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
        return;
      }

      if (hasError) return; // Detener la función si hay errores

      try {
        const response = await axios.post("/cards", {
          pkidcard: this.selectedCard.pkidcard,
          card_number: this.selectedCard.card_number.replace(/\s/g, ""),
          card_type: this.selectedCard.card_type,
          active: this.selectedCard.active,
          fkid_accreditation_document_detail: this.$route.params.id,
          user_creation: decryptString(localStorage.getItem("idUser")),
        });

        await this.loadCards();

        this.$bvToast.toast("Tarjeta creada correctamente", {
          title: "Éxito",
          variant: "success",
          solid: true,
        });

        this.showCreateModal = false;
        this.resetForm();
      } catch (error) {
        const msg =
          (error.response && error.response.data && error.response.data.error) ||
          "Error al intentar crear la credencial. Inténtalo de nuevo.";

        this.$bvToast.toast(msg, {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      }
    },

    resetForm() {
      this.selectedCard = {
        pkidcard: null,
        card_number: "",
        card_type: "",
        active: false,
        user_creation: "",
      };
    },

    //cargar las tarjetas
    async loadCards() {
      const pkid_accreditation_document_detail = this.$route.params.id;
      try {
        const result = await axios.get("/getCardByUsuari", {
          params: { pkid_accreditation_document_detail },
        });
        this.items = result.data.map((card) => ({
          pkidcard: card.pkidcard,
          Fkid_accreditation_document_detail:
            card.fkid_accreditation_document_detail,
          card_number: card.card_number,
          card_type: card.card_type,
          active: card.active,
          timestamp_modification: card.timestamp_modification,
          user_creation: card.user_creation,
          timestamp_creation: card.timestamp_creation,
          user_name: card.User_name

        }));
      } catch (error) {
        console.error("Error al cargar las tarjetas:", error);
      }
    },

    //funcion para activar o desactivar las puertas con el swtich
    async onToggleActive(item) {
      // Simplemente invierte el valor local
      item.tempActive = !item.tempActive;
    },
  },

  computed: {
    dooraccesoptions() {
      return this.dooracces.map((acc) => ({ text: acc, value: acc }));
    },
    docStatusOptions() {
      return this.docStatus;
    },

    statusVariant() {
      const statusColor = {
        OK: "light-success",
        OK_Exit: "light-warning",
        "OK_Exit+": "light-warning",
        OK_entered: "light-info",
        ERROR: "light-danger",
        "INCORRECTO No es válido realizar movimineto de salida": "light-danger",
        REPETIT: "light-danger",
        "Fecha de vencimiento fuera de plazo": "light-danger",
        "Fecha de fin de validez fuera de plazo": "light-danger",
        "Fecha de caducidad fuera de plazo": "light-danger",
        "No existe documento en detalle del evento": "light-danger",
        "En baja: Entrada a baja": "light-danger",
        "ERROR DNI ACREDITACIÓN duplicado": "light-danger",
        "ACREDITACIÓN Anulada": "light-danger",
        "DENEGADA ACREDITACIÓN": "light-danger",
      };
      return (status) => statusColor[status];
    },
  },

  data() {
    return {
      required,
      disable: false,
      hiddenComponent: false,
      togglePlaintext: false,
      dniOptions: [
        { text: "DNI", value: "DNI" },
        { text: "Otro", value: "Other" },
      ],
      companySeleceted: ",",
      companies: [],
      perPage: 10,
      manualEntry: false,
      manualCompanyName: '',
      pageOptions: [5, 10, 20, 50],
      totalRows: 1,
      currentPage: 1,
      items: [],
      items1: [],
      items2: [],
      filter2: "",
      aforoMainSelected: "",
      dooracces: [],
      timetables: [],
      docStatus: [],
      docStatusSelected: "",
      timetableOptions: [],
      matriculasInput: "",
      Matricula: [],
      aforos: [],
      aforoPermitSelected: [],
      isEditing: true,
      fields: [
        { key: "pkidcard", label: "ID" },
        { key: "card_number", label: "Número" },
        { key: "card_type", label: "Tipo" },
        { key: "active", label: "Activo", formatter: (value) => !!value },
        {
          key: "timestamp_modification",
          label: "Fecha Modificación",
          formatter: (value) => {
            return value ? moment(value).utc().format("DD/MM/YYYY HH:mm") : "";
          },
        },
        { key: "user_name", label: "Creación Usuario " },
        {
          key: "timestamp_creation",
          label: "Fecha creación",
          formatter: (value) => {
            return value ? moment(value).utc().format("DD/MM/YYYY HH:mm") : "";
          },
        },
        { key: "actions", label: "Acciones" },
      ],
      fields1: [
        { key: "pkid_accreditation_sca_registry", label: "Id" },
        {
          key: "timestamp_creacio",
          label: "Fecha Creación",
          formatter: (value) => {
            return value ? moment(value).utc().format("DD/MM/YYYY HH:mm") : "";
          },
        },
        {
          key: "timestamp_pda",
          label: "PDA Tiempo",
          formatter: (value) => {
            return value ? moment(value).utc().format("DD/MM/YYYY HH:mm") : "";
          },
        },
        { key: "source", label: "Fuente" },
        { key: "ID_user", label: "ID User" },
        { key: "way", label: "Vía" },
        { key: "DoorName", label: "Nombre Puerta" },
        { key: "fkid_accreditation", label: "Acreditación" },
        { key: "fkid_mxs_event", label: "Evento" },
        { key: "StatusDescription", label: "Estado" },
        { key: "StatusDescription_Offline", label: "Estado Sin Conexión" },
      ],
      fields2: [
        { key: "Active", label: "Estado" },
        { key: "Aforo_name", label: "Aforo" },
        { key: "Name", label: "Nombre Puerta" },
      ],
      errors: {
        card_number: '',
        card_type: '',
      },
      showEditModal: false,
      showDeleteModal: false,
      showCreateModal: false,
      selectedCard: {
        pkidcard: null,
        fkid_accreditation_document_detail: null,
        card_number: "",
        card_type: "",
        active: false,
        user_creation: "",
      },
      refreshInterval: null,
      pollInterval: 5000,
      cardTypeOptions: [
        { text: "MiFare", value: "mifare" },
        { text: "CarPlate", value: "carplate" },
      ],
      activeLabel: [
        {
          mifare: "-MiFare",
          carplate: "-CarPlate",
        },
        {
          mifare: "default",
          carplate: "default",
        },
      ],
      filters: {
        startDateFilter: moment().subtract(7, "days").format("YYYY-MM-DD"),
        endDateFilter: moment().format("YYYY-MM-DD"),
      },
      filtersConfig: [
        {
          key: "startDateFilter",
          label: "Rango de Fechas",
          type: "date-range",
          param: "datetime_start_acreditation",
          formatter: (value) =>
            value ? moment(value).format("YYYY-MM-DD") : null,
        },
      ],
    };
  },

  async created() {
    this.loadCards();
    const pkid_accreditation_document_detail = this.$route.params.id;
    await this.applyFilter();



    //para cargar las compañias que tenemos 
    await axios
      .get("/company")
      .then((results) => {
        results.data.forEach((element) => {
          this.companies.push(
            element.Name + " - (" + element.pkid_accreditation_company + ")"
          );
        });
      })
      .catch((error) => {
        const variant = "danger";
        this.$bvToast.toast("Fallo al conectar", {
          title: "" + error,
          variant,
          solid: true,
        });
      });

    await axios
      .get("/docStatus")
      .then((results) => {
        results.data.forEach((element) => {
          this.docStatus.push(
            element.pkid_accreditation_status + " - " + element.Description
          );
        });
      })
      .catch((error) => {
        const variant = "danger";
        this.$bvToast.toast("Fallo al conectar", {
          title: `` + error,
          variant,
          solid: true,
        });
      });

    //para cargar los datos del empleado 
    await axios
      .get(
        "/employees" +
        "?pkid_accreditation_document_detail=" +
        pkid_accreditation_document_detail
      )
      .then((result) => {
        const employee = result.data.find(
          (emp) =>
            emp.pkid_accreditation_document_detail ==
            pkid_accreditation_document_detail
        );
        if (employee) {
          this.body = employee;

          if (employee.fkid_accreditation_status && employee.DocStatus) {
            this.docStatusSelected =
              employee.fkid_accreditation_status + " - " + employee.DocStatus;
          }

          if (employee.pkid_accreditation_company) {
            this.companySeleceted = employee.Empresa_nom + " - (" + employee.pkid_accreditation_company + ")";//employee.pkid_accreditation_company; // solo el ID
          } else {
            this.body.manualEntry = true;
            this.body.manualCompanyName = employee.Empresa_nom;
          }

          if (employee.fkid_timetable) {
            this.body.timetables = employee.fkid_timetable;
          }
          if (!this.body.DOI_Type) {
            this.body.DOI_Type = "Other";
          }
        } else {
          console.error("No se encontraron datos para el pkid proporcionado.");
        }
      });



    ///FUncion para cargar el usuario antes de pasarlo a las puertas
    const currentUserRaw = localStorage.getItem("userData");

    if (!currentUserRaw) {
      console.error("No hay ningún 'userData' guardado en localStorage");
      return;
    }

    let currentUser;
    try {
      currentUser = JSON.parse(currentUserRaw);
    } catch (e) {
      console.error("Error parseando 'userData' desde localStorage:", e);
      return;
    }

    if (currentUser && (currentUser.ID_user || currentUser.ID_usuari)) {
      this.body.ID_usuari_creacio =
        currentUser.ID_user || currentUser.ID_usuari;
    } else {
      console.error("No se encontró el usuario autenticado válido.");
    }




    axios
      .get(`/userAcces?userId=${this.body.ID_usuari_creacio}`)
      .then((response) => {
        const aforosPermitidos = response.data.map((item) => item.ID_Aforo);

        // Obtener todos los aforos activos
        axios
          .get(`/aforo?Active=1`)
          .then((results) => {
            // Filtrar los aforos permitidos
            const aforosFiltrados = results.data.filter((element) =>
              aforosPermitidos.includes(element.ID_Aforo)
            );

            // Mapear los aforos filtrados
            this.aforos = aforosFiltrados.map(
              (element) => `${element.Aforo_name} - (${element.ID_Aforo})`
            );

            // Preparar IDs para enviar en una sola petición
            const ids = aforosFiltrados.map((aforo) => aforo.ID_Aforo).join(',');

            // Hacer una sola petición con todos los IDs
            axios
              .get(`/dooracces?ID_Aforo=${ids}`)
              .then((doorResults) => {
                // doorResults.data es un array con todas las puertas
                // Mapear las puertas AccesSCA
                this.dooracces = doorResults.data
                  .map((element) => element.AccesSCA)
                  .flat();
              })
              .catch((error) => {
                console.error("Error al obtener las puertas para los aforos", error);
                this.dooracces = [];
                const variant = "danger";
                this.$bvToast.toast("Fallo al conectar el acceso de la puerta", {
                  title: "" + error,
                  variant,
                  solid: true,
                });
              });
          })
          .catch((error) => {
            const variant = "danger";
            this.$bvToast.toast("Fallo al conectar la fecha de aforo", {
              title: "" + error,
              variant,
              solid: true,
            });
          });
      })
      .catch((error) => {
        const variant = "danger";
        this.$bvToast.toast("Fallo al conectar los datos de acceso del usuario", {
          title: "" + error,
          variant,
          solid: true,
        });
      });


    //cargar las tarjetas del usuario
    axios
      .get("/getCardByUsuari", {
        params: {
          pkid_accreditation_document_detail:
            pkid_accreditation_document_detail,
        },
      })
      .then((result) => {
        const cards = result.data;
        if (cards.length > 0) {
          this.items = cards.map((card) => ({
            pkidcard: card.pkidcard,
            Fkid_accreditation_document_detail:
              card.fkid_accreditation_document_detail,
            card_number: card.card_number,
            card_type: card.card_type,
            active: card.active,
            timestamp_modification: card.timestamp_modification,
            user_creation: card.user_creation,
            timestamp_creation: card.timestamp_creation,
            user_name: card.User_name
          }));
        } else {
        }
      })
      .catch((error) => {
        const variant = "danger";
        this.$bvToast.toast("Fallo al conectar", {
          title: `Error: ${error}`,
          variant,
          solid: true,
        });
      });



    axios
      .get(`/userAcces?userId=${decryptString(localStorage.getItem("idUser"))}`)
      .then((response) => {
        const aforosPermitidos = response.data.map((item) => item.ID_Aforo);

        return axios.get(`/aforo?Active=1`).then((results) => {
          const aforosFiltrados = results.data.filter((element) =>
            aforosPermitidos.includes(element.ID_Aforo)
          );

          // Aquí se hace una sola petición con todos los IDs separados por coma
          const ids = aforosFiltrados.map((aforo) => aforo.ID_Aforo).join(',');

          return axios.get(`/dooracces?ID_Aforo=${ids}`).then((doorResults) => {
            const puertasPermitidas = doorResults.data.map((element) => element.AccesSCA);
            return puertasPermitidas;
          });
        });
      })
      .then((puertasPermitidas) => {
        const codigosPermitidos = puertasPermitidas
          .map((p) => p.split(","))
          .flat();

        return axios
          .get(`/accred-sca-registry/${pkid_accreditation_document_detail}`)
          .then((result) => {
            const data = result.data;

            if (Array.isArray(data) && data.length > 0) {
              const puertasFiltradas = data.filter((item) => {
                const codigosPuerta = item.AccesSCA.split(",");
                return codigosPuerta.some((codigo) =>
                  codigosPermitidos.includes(codigo)
                );
              });

              this.items2 = puertasFiltradas.map((item) => ({
                ...item,
                tempActive: item.Active === 1,
              }));
            } else {
              this.items2 = [];
              console.warn("No se encontraron resultados.");
            }
          });
      })
      .catch((error) => {
        const variant = "danger";
        this.$bvToast.toast("Error al cargar datos: " + error, {
          title: "Error",
          variant,
          solid: true,
        });
      });



    //cargar los horarios en el desplegable
    axios
      .get("/timetable")
      .then((response) => {
        this.timetableOptions = [
          { value: null, text: "" },
          ...response.data.map((timetable) => ({
            value: timetable.pkid_timetable,
            text: `${timetable.name} - ${timetable.description}`,
          })),
        ];
      })
      .catch((error) => {
        console.error("Error al cargar los horarios", error);
        this.$bvToast.toast("Error al cargar los horarios", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      });

  },

  mounted() {
    if (localStorage.getItem("accessToken") === null) {
      this.$router.go(0);
    }
  },
  setup() {
    const userId = decryptString(localStorage.getItem("idUser")) || "unknown";

    const blankPersonData = {
      Nom_titular: "",
      Cognom1_titular: "",
      Cognom2_titular: "",
      DOI_Type: "",
      AccesSCA: "",
      DNI: "",
      Data_neixament: "",
      datetime_start_acreditation: "",
      datetime_end_acreditation: "",
      email: "",
      timetables: null,
      ID_usuari_modificacio: userId,
      ID_usuari_creacio: userId,
    };

    const body = ref({ ...blankPersonData });


    const onSubmit = async () => {

      const onError = [false, ""];
      body.value.ID_usuari_modificacio =
        decryptString(localStorage.getItem("idUser")) || userId;

      // Asignar el nombre de empresa según si es manual o select
      if (body.value.manualEntry) {
        body.value.pkid_accreditation_company = '';
        body.value.Empresa_nom = body.value.manualCompanyName.trim();
      }

      try {
        await axios.put("/employeesDNI", body.value);

        await axios.post("/insertTimetable", {
          fkid_accreditation_document_detail:
            body.value.pkid_accreditation_document_detail,
          fkid_timetable: body.value.timetables,
        });

        return [false, body.value.pkid_accreditation_document_detail];
      } catch (error) {
        onError[0] = true;

        if (error.response && error.response.data && error.response.data.Error) {
          onError[1] = error.response.data.Error; // Mensaje del backend
        } else {
          onError[1] = "Error inesperado. Verifica la conexión o los datos.";
        }

        return onError;
      }

      return onError;
    };

    return {
      body,
      onSubmit,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
